// @ts-nocheck
import { Breakpoints } from '@lmig/lmds-helpers/dist/types/breakpoints';
import breakpointTokens from '@lmig/lmds-tokens/dist/json/core/breakpoint.json';
import { useMediaQuery } from './useMediaQuery';

export function useMinBreakpoint(breakpoint?: Breakpoints | 'always' | 'never' | 'custom'): boolean {
  let mediaQuery = '';
  if (breakpoint === 'always') {
    mediaQuery = '(min-width: 0px)';
  } else if (breakpoint === 'never') {
    mediaQuery = '(max-width: 0px)';
  } else if (breakpoint === 'custom') {
    mediaQuery = '(min-width: 1081px)';
  } else {
    const minWidth = breakpointTokens.lmig.breakpoint[breakpoint].raw.toString();
    mediaQuery = `(min-width: ${minWidth}px)`;
  }

  return useMediaQuery(mediaQuery);
}
